// Report.js
import React from "react"

import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
} from "@react-pdf/renderer"
import { getDateFn } from "./ReportUtility"

//const border_color = "gray"
const bg_color = "silver"

const styles = StyleSheet.create({
    page: {
        flexDirection: "row",
        backgroundColor: "#ffffff",
        fontFamily: "Helvetica",

    },
    section: {
        margin: 20,

        flexGrow: 1,
        fontSize: "9px",
    },
    d_header: {
        // fontSize: "10px",
        // padding: "3px",
        border: "1px",

        borderBottom: 0,

        textAlign: "center",
    },
    t_comptitle: {
        fontSize: "12px",
        textAlign: "center",
        textTransform: "uppercase",
        fontWeight: "bold",
        padding: "3px",
    },
    mainflexdiv: {
        border: "1px",
        borderColor: "#000000",
        // borderLeft:0,
        borderBottom: 0,
        width: "50%",
        padding: "2px 5px 5px 5px",
    },
    dflex: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "top",
    },

    srno: {
        width: "25%",
        overflow: "hidden"
    },
    taka: {
        width: "40%",
        overflow: "hidden"
    },
    meter: {
        width: "40%",
        overflow: "hidden"
    },
    taka_box: {
        width: "20%",
        border: "1px",


    },
    font_bold: {
        fontFamily: "Helvetica-Bold",

    },
    table: {
        display: 'table',
        width: '100%',
    },
    tableRow: {
        // margin: 'auto',
        flexDirection: 'row',
        width: '100%',
        // backgroundColor:"#000000"
    },
    tableCol: {
        width: '100%',
        padding: "3px 0px"

    },

    tableColItem: {
        fontSize: "9px",
        paddingTop: "3px",


    },
    tableColItemheader: {
        backgroundColor: bg_color,
        padding: "5px",
        paddingRight: 0,
        paddingLeft: 0
    },
    tableCellItem: {
        textAlign: "center",
        paddingBottom: "1px"

    },
    box2_first_colWidth: {
        width: "25%"
    },
    box2_second_colWidth: {
        width: "70%",
    },
    middle_colWidth: {
        width: "5%"
    },
    colBorder: { borderRight: "1px dotted rgb(151, 151, 151)", borderBottom: "0px" },

    font_size: {
        fontSize: "9px"
    },
    row_data: {
        lineHeight: "2"
    },

})

// Create PDF component
const RptChallan = ({ chaldata }) => {
    let total_Taka = 0
    let total_Mtr = 0
    let data = []
    let detail = []
    let bunches = []
    let loop = [{ id: 1 }, { id: 2 }]
    if (data.length <= 0 && detail.length <= 0) {
        if (chaldata && Object.keys(chaldata)?.length > 0) {
            data = chaldata?.billData //billdetai
            let objChallan = chaldata?.challanData //chaldata?.challanData.filter(ele => ele.isAdded == 1)
            for (let i = 0; i < 60; i += 12) {
                bunches.push(objChallan.slice(i, i + 12));
            }
            detail = bunches
        }

    }
    return (
        <Document pageMode="fullScreen">
            <Page size="A4" style={styles.page}>
                {
                    data && data.map((item, index) => {

                        return (
                            <>
                                <View style={styles.section}>
                                    {/* HEader */}
                                    <View>
                                        <div style={styles.d_header}>
                                            <div>
                                                <Text style={[styles.t_comptitle, styles.font_bold]}>DELIVERY CHALLAN</Text>
                                            </div>

                                        </div>
                                        {/* end header */}
                                        {/* Invoice */}

                                        <View style={[styles.table]}>
                                            <View style={[styles.tableRow]}>
                                                <View style={[styles.tableCol, styles.mainflexdiv,]}>

                                                    <View style={[styles.table,]}>
                                                        <View style={[styles.tableRow]}>
                                                            <View style={[styles.tableCol, styles.font_bold]}>
                                                                <Text style={styles.tableCell}>{item.compname}</Text>
                                                            </View>

                                                        </View>
                                                        <View style={[styles.tableRow]}>
                                                            <View style={[styles.tableCol,]}>
                                                                <Text style={styles.tableCell}>  {item.comp_add1 +
                                                                    " " +
                                                                    item.comp_add2 +
                                                                    " " +
                                                                    item.comp_add3 +
                                                                    " " +
                                                                    item.comp_add4}</Text>
                                                            </View>

                                                        </View>
                                                        <View style={[styles.tableRow]}>
                                                            <View style={[styles.tableCol,]}>
                                                                <Text style={styles.tableCell}> Contact No :{item.comp_contectno1 + " , " + item.comp_contectno2}</Text>
                                                            </View>

                                                        </View>
                                                        <View style={[styles.tableRow]}>
                                                            <View style={[styles.tableCol, styles.font_bold]}>
                                                                <Text style={styles.tableCell}> GST No :{item.Comp_GST_No}</Text>
                                                            </View>

                                                        </View>
                                                    </View>
                                                </View>
                                                {/* new colu,mn */}
                                                <View style={[styles.tableCol, styles.mainflexdiv, { borderLeft: 0 }]}>
                                                    <View style={[styles.table,]}>
                                                        <View style={[styles.tableRow]}>
                                                            <View style={[styles.tableCol, styles.box2_first_colWidth]}>
                                                                <Text style={styles.tableCell}>Challan No.</Text>
                                                            </View>
                                                            <View style={[styles.tableCol, styles.middle_colWidth]}>
                                                                <Text style={styles.tableCell}> :</Text>
                                                            </View>
                                                            <View style={[styles.tableCol, styles.box2_second_colWidth,]}>
                                                                <View style={[styles.tableCell, styles.dflex,]}>
                                                                    <Text style={styles.font_bold}>{item.Chal_No}</Text>

                                                                    <Text style={styles.font_bold}> Date:{getDateFn(item.Chal_Date)}</Text>
                                                                </View>
                                                            </View>
                                                        </View>
                                                        <View style={[styles.tableRow]}>
                                                            <View style={[styles.tableCol, styles.box2_first_colWidth]}>
                                                                <Text style={styles.tableCell}>Quality</Text>
                                                            </View>
                                                            <View style={[styles.tableCol, styles.middle_colWidth]}>
                                                                <Text style={styles.tableCell}> :</Text>
                                                            </View>
                                                            <View style={[styles.tableCol, styles.box2_second_colWidth, styles.font_bold]}>
                                                                <Text style={styles.tableCell}>{item?.Item_Desc}</Text>
                                                                <Text style={styles.tableCell}>HSN No : {item?.HSNNo}</Text>
                                                            </View>

                                                        </View>
                                                        <View style={[styles.tableRow]}>
                                                            <View style={[styles.tableCol, styles.box2_first_colWidth]}>
                                                                <Text style={styles.tableCell}>Transporter</Text>
                                                            </View>
                                                            <View style={[styles.tableCol, styles.middle_colWidth]}>
                                                                <Text style={styles.tableCell}> :</Text>
                                                            </View>
                                                            <View style={[styles.tableCol, styles.box2_second_colWidth,]}>
                                                                <Text style={styles.tableCell}>{item?.TAc_Desc}</Text>
                                                            </View>

                                                        </View>
                                                        <View style={[styles.tableRow]}>
                                                            <View style={[styles.tableCol, styles.box2_first_colWidth]}>
                                                                <Text style={styles.tableCell}>Vehicle</Text>
                                                            </View>
                                                            <View style={[styles.tableCol, styles.middle_colWidth]}>
                                                                <Text style={styles.tableCell}> :</Text>
                                                            </View>
                                                            <View style={[styles.tableCol, styles.box2_second_colWidth,]}>
                                                                <Text style={styles.tableCell}>{item?.VehNo}</Text>
                                                            </View>

                                                        </View>
                                                        <View style={[styles.tableRow]}>
                                                            <View style={[styles.tableCol, styles.box2_first_colWidth]}>
                                                                <Text style={styles.tableCell}>Broker</Text>
                                                            </View>
                                                            <View style={[styles.tableCol, styles.middle_colWidth]}>
                                                                <Text style={styles.tableCell}> :</Text>
                                                            </View>
                                                            <View style={[styles.tableCol, styles.box2_second_colWidth,]}>
                                                                <Text style={styles.tableCell}>{item?.BAc_Desc}</Text>
                                                            </View>

                                                        </View>
                                                    </View>
                                                </View>

                                            </View>
                                        </View>
                                        {/* /end invoice */}
                                        {/* //bill section */}

                                        <div>
                                            <View style={[styles.table]}>
                                                <View style={[styles.tableRow]}>
                                                    <View style={[styles.tableCol, styles.mainflexdiv,]}>
                                                        <View style={[styles.table, {}]}>
                                                            <View style={[styles.tableRow]}>
                                                                <View style={[styles.tableCol, styles.font_bold, { fontSize: "10px" }]}>
                                                                    <Text style={styles.tableCell}>M/s</Text>
                                                                </View>

                                                            </View>
                                                            <View style={[styles.tableRow]}>
                                                                <View style={[styles.tableCol, styles.font_bold]}>
                                                                    <Text style={styles.tableCell}>{item.PAc_Desc}</Text>
                                                                </View>
                                                            </View>
                                                            <View style={[styles.tableRow]}>
                                                                <View style={[styles.tableCol, { height: "30px", overflow: "hidden" }]}>
                                                                    <Text style={styles.tableCell}>{item?.PAdd_1 +
                                                                        item?.PAdd_2 +
                                                                        item?.PAdd_3 +
                                                                        item?.PAdd_4}</Text>
                                                                </View>

                                                            </View>
                                                            <View style={[styles.tableRow]}>
                                                                <View style={[styles.tableCol, styles.font_bold,]}>
                                                                    <Text style={styles.tableCell}><Text style={[styles.font_bold]}> GST No : </Text>  {item?.Party_GST_No}</Text>
                                                                </View>

                                                            </View>

                                                        </View>
                                                    </View>
                                                    {/* new colu,mn */}
                                                    <View style={[styles.tableCol, styles.mainflexdiv, { borderLeft: 0 }]}>
                                                        <View style={[styles.table,]}>

                                                            <View style={[styles.tableRow]}>
                                                                <View style={[styles.tableCol, , styles.font_bold, { fontSize: "10px" }]}>
                                                                    <Text style={styles.tableCell}>Delivery At</Text>
                                                                </View>
                                                            </View>
                                                            <View style={[styles.tableRow]}>
                                                                <View style={[styles.tableCol, styles.box4_second_colWidth, styles.font_bold]}>
                                                                    <Text style={styles.tableCell}>{item?.DAc_Desc}</Text>
                                                                </View>
                                                            </View>

                                                            <View style={[styles.tableRow]}>
                                                                <View style={[styles.tableCol, { height: "30px", overflow: "hidden" }]}>
                                                                    <Text style={styles.tableCell}>{item?.DAdd_1 + item?.DAdd_2 + item?.DAdd_3}</Text>
                                                                </View>
                                                            </View>
                                                            <View style={[styles.tableRow]}>
                                                                <View style={[styles.tableCol,]}>
                                                                    <Text style={styles.tableCell}><Text style={[]}> GST No : </Text> {item?.DGst_No}</Text>
                                                                </View>
                                                            </View>
                                                        </View>
                                                    </View>
                                                </View>
                                            </View>

                                        </div>
                                    </View >
                                    {/* /*EndBilll_section */}
                                    {/* Main section */}
                                    <div style={{}}>
                                        {

                                            (<View style={[styles.table, { borderLeft: 0 }]}>
                                                <View style={[styles.tableRow, { borderBottom: "1px", margin: "0", }]}>{
                                                    detail.map((item, i) => {

                                                        let box_totalMtr = 0
                                                        let box_totalTaka = 0
                                                        return (
                                                            <View style={[styles.taka_box, {}]}>

                                                                <View style={[styles.table]}>
                                                                    <View style={[styles.tableRow, styles.font_bold, { borderBottom: "1px", borderTop: "1px" }]}>
                                                                        <View style={[styles.tableColItemheader, styles.srno, styles.colBorder]}>
                                                                            <Text style={[styles.tableCellItem]}>No.</Text>
                                                                        </View>
                                                                        <View style={[styles.tableColItemheader, styles.taka, styles.colBorder]}>
                                                                            <Text style={[styles.tableCellItem]}>Taka No.</Text>
                                                                        </View>
                                                                        <View style={[styles.tableColItemheader, styles.meter, styles.colBorder]}>
                                                                            <Text style={[styles.tableCellItem]}>MTRS.</Text>
                                                                        </View>
                                                                    </View>
                                                                </View>
                                                                <View style={[styles.table, { backgroundColor: "#FFFFFF" }]}>
                                                                    {detail[i].map((itemlist, inx) => {
                                                                        if (itemlist.isAdded) {
                                                                            box_totalMtr += parseFloat(itemlist.Meter)
                                                                            box_totalTaka += 1
                                                                            total_Taka += 1
                                                                            total_Mtr += parseFloat(itemlist.Meter)
                                                                        }
                                                                        return (
                                                                            <View style={[styles.tableRow, {}]} >
                                                                                <View style={[styles.tableColItem, styles.srno, styles.colBorder]}>
                                                                                    <Text style={[styles.tableCellItem, styles.row_data]}>{itemlist.isAdded ? itemlist.Lot_No != "" ? itemlist.Id + "/" + itemlist.Lot_No : itemlist.Id : " "}</Text>
                                                                                </View>
                                                                                <View style={[styles.tableColItem, styles.taka, styles.colBorder]}>
                                                                                    <Text style={[styles.tableCellItem, styles.row_data,]}>{itemlist.isAdded ? itemlist.Taka_No : ""}</Text>
                                                                                </View>
                                                                                <View style={[styles.tableColItem, styles.meter, styles.colBorder]}>
                                                                                    <Text style={[styles.tableCellItem, styles.row_data]}>{itemlist.isAdded ? itemlist.Meter : ""}</Text>
                                                                                </View>
                                                                            </View>

                                                                        )
                                                                    })}
                                                                    <View style={[styles.tableRow, { borderTop: "1px", paddingTop: "5px", fontSize: "11px" }]} >
                                                                        <View style={[styles.tableColItem, styles.srno, styles.font_bold,]}>
                                                                            <Text style={[styles.tableCellItem, styles.row_data]}>{i == 0 ? "Total" : ""}</Text>
                                                                        </View>
                                                                        <View style={[styles.tableColItem, styles.taka,]}>
                                                                            <Text style={[styles.tableCellItem, styles.row_data,]}>{box_totalTaka > 0 ? box_totalTaka : " "}</Text>
                                                                        </View>
                                                                        <View style={[styles.tableColItem, styles.meter, styles.font_bold,]}>
                                                                            <Text style={[styles.tableCellItem, styles.row_data]}>{box_totalMtr > 0 ? box_totalMtr : " "}</Text>
                                                                        </View>
                                                                    </View>
                                                                </View>
                                                            </View>
                                                        )
                                                    })
                                                }
                                                </View>
                                                {/* footer */}
                                                <View style={[styles.tableRow, { borderBottom: "1px dashed gray", borderLeft: 1, borderRight: 1, borderTop: 0, margin: "0" }]}>
                                                    <View style={[styles.font_bold, {
                                                        display: "flex", paddingLeft: 0,
                                                        padding: "5px", flexDirection: "row", fontSize: "12px"
                                                    }]}>
                                                        <View style={{ width: "50%" }}><Text >Total Pcs : {total_Taka > 0 ? total_Taka : " "}</Text></View>
                                                        <View> <Text> Meter : {total_Mtr > 0 ? total_Mtr : " "}</Text></View>
                                                    </View>
                                                </View>
                                                <View style={[styles.tableRow, { borderLeft: 1, borderRight: 1, borderBottom: "1px" }]}>
                                                    <View style={[styles.font_bold, {
                                                        display: "flex", paddingLeft: 0,
                                                        padding: "10px", flexDirection: "row",
                                                    }]}>
                                                        <View style={{ width: "60%", textDecoration: "underline", fontSize: "10px" }}><Text >Receiver's Signature:</Text></View>
                                                        <View> <Text> For : {item.compname}</Text></View>
                                                    </View>
                                                </View>
                                                {/* end footer */}
                                            </View>)
                                        }
                                    </div>
                                    {/* /End main */}
                                </View >
                            </>
                        )
                    })
                }

            </Page >
        </Document >
    )
}
export default RptChallan


